import { Controller, useFormContext } from 'react-hook-form';
import type { HookFileInputProps } from '../../HookForm/Form/File';
import { FileInputFieldBase } from '../../HookForm/Form/File/FileInputFieldBase';

export interface JsonHookFileInputProps extends HookFileInputProps {
  currentStep: number;
}
export const JsonHookFileInput = (props: JsonHookFileInputProps) => {
  const { name = '', required, validate, multiple, currentStep = 0, ...rest } = props;
  const { control, watch, setValue } = useFormContext();

  /**
   * Common for all the forms
   * all the file inputs files are under same name
   * is an object with array of files in the name specified by the user in json form
   *
   * example
   *
   * selectedFiles : {
   * [name]:[File1,File2,File3]
   * }
   */
  const fileInputSelectedFilesName = 'selectedFiles';

  const allFormFiles = watch(fileInputSelectedFilesName) || {};
  const currentStepFiles = allFormFiles[currentStep] || {};
  const files = currentStepFiles[name] || [];

  const removeFile = (index: number) => {
    const filesCopy = [...files];
    filesCopy.splice(index, 1);
    setValue(fileInputSelectedFilesName, {
      ...allFormFiles,
      [currentStep]: {
        ...currentStepFiles,
        [name]: [...filesCopy],
      },
    });
  };

  return (
    <Controller
      name={name}
      rules={{ required: required && 'Required', validate }}
      control={control}
      render={({ field, fieldState: { error, isTouched } }) => {
        const totalFiles = ((files as File[]) || []).length;
        return (
          <FileInputFieldBase
            {...rest}
            {...field}
            key={`${files?.length}`}
            value={
              totalFiles > 1
                ? `${totalFiles} file${totalFiles > 1 ? 's' : ''} selected`
                : totalFiles === 1
                  ? files[0].name
                  : rest.placeholder
            }
            onChange={(e) => {
              if (multiple) {
                setValue(fileInputSelectedFilesName, {
                  ...allFormFiles,
                  [currentStep]: {
                    ...currentStepFiles,
                    [name]: [...files, ...Array.from<File>(e.target.files || [])],
                  },
                });
              } else {
                setValue(fileInputSelectedFilesName, {
                  ...allFormFiles,
                  [currentStep]: {
                    ...currentStepFiles,
                    [name]: Array.from<File>(e.target.files || []),
                  },
                });
              }
            }}
            error={isTouched ? error?.message : ''}
            multiple={multiple}
            files={files}
            removeFile={removeFile}
          />
        );
      }}
    />
  );
};
